import configManager from "../singleton/ConfigManager";
import { SOUND_SPAWN_PEN } from "../systems/sound-effects-system";
/**
 * HUD panel for muting, freezing, and other controls that don't necessarily have hardware buttons.
 * @namespace ui
 * @component in-world-hud
 */
AFRAME.registerComponent("in-world-hud", {
  init() {
    this.mic = this.el.querySelector(".mic");
    this.spawn = this.el.querySelector(".spawn");
    this.pen = this.el.querySelector(".penhud");
    this.cameraBtn = this.el.querySelector(".camera-btn");
    this.inviteBtn = this.el.querySelector(".invite-btn");
    this.background = this.el.querySelector(".bg");
    this.participantsBtn = this.el.querySelector(".participants-btn");

    this.onMicStateChanged = () => {
      this.mic.setAttribute("mic-button", "active", APP.dialog.isMicEnabled && configManager.config.voiceChat.enabled);
    };
    APP.dialog.on("mic-state-changed", this.onMicStateChanged);

    this.updateButtonStates = () => {
      this.mic.setAttribute("mic-button", "active", APP.dialog.isMicEnabled && configManager.config.voiceChat.enabled);
      this.pen.setAttribute("icon-button", "active", this.el.sceneEl.is("pen"));
      this.cameraBtn.setAttribute("icon-button", "active", this.el.sceneEl.is("camera"));
      if (window.APP.hubChannel) {
        const canSpawnMedia = window.APP.hubChannel.can("spawn_and_move_media");
        const canDraw = window.APP.hubChannel.can("spawn_drawing");
        const canSpawnCamera = window.APP.hubChannel.can("spawn_camera");

        this.spawn.setAttribute("icon-button", "disabled", !canSpawnMedia);
        this.spawn.setAttribute(
          "icon-button",
          "tooltipText",
          canSpawnMedia ? "Assets" : "You don't have permission to place objects"
        );

        this.pen.setAttribute("icon-button", "disabled", !canDraw);
        this.pen.setAttribute("icon-button", "tooltipText", canDraw ? "Pen" : "You don't have permission to draw");

        this.cameraBtn.setAttribute("icon-button", "disabled", !canSpawnCamera);
        this.cameraBtn.setAttribute(
          "icon-button",
          "tooltipText",
          canSpawnCamera ? "Camera" : "You don't have permission to spawn a camera"
        );
      }
    };

    this.onStateChange = evt => {
      if (!(evt.detail === "frozen" || evt.detail === "pen" || evt.detail === "camera")) return;
      this.updateButtonStates();
    };

    this.onMicClick = () => {
      const isMicAvailable = window.APP.mediaDevicesManager?.selectedMicDeviceId !== "none";

      if (
        !window.APP.hubChannel.can("voice_chat") ||
        !isMicAvailable ||
        configManager.config.voiceChat.enabled === false
      )
        return;

      APP.mediaDevicesManager.toggleMic();
    };

    this.onSpawnClick = () => {
      if (!window.APP.hubChannel.can("spawn_and_move_media")) return;
      this.el.emit("action_spawn");
    };

    this.onPenClick = e => {
      if (!window.APP.hubChannel.can("spawn_drawing")) return;
      this.el.emit("spawn_pen", { object3D: e.object3D });
      this.el.sceneEl.systems["hubs-systems"].soundEffectsSystem.playSoundOneShot(SOUND_SPAWN_PEN);
    };

    this.onCameraClick = () => {
      if (!window.APP.hubChannel.can("spawn_camera")) return;
      this.el.emit("action_toggle_camera");
    };

    this.onInviteClick = () => {
      this.el.emit("action_invite");
    };

    this.onHubUpdated = e => {
      this.inviteBtn.object3D.visible = e.detail.hub.entry_mode !== "invite";
    };

    this.onParticipantsClick = () => {
      this.el.emit("action_participants");
    };
  },

  play() {
    this.el.sceneEl.addEventListener("stateadded", this.onStateChange);
    this.el.sceneEl.addEventListener("stateremoved", this.onStateChange);
    this.el.sceneEl.systems.permissions.onPermissionsUpdated(this.updateButtonStates);
    this.el.sceneEl.addEventListener("hub_updated", this.onHubUpdated);
    this.updateButtonStates();

    this.mic.object3D.addEventListener("interact", this.onMicClick);
    this.spawn.object3D.addEventListener("interact", this.onSpawnClick);
    this.pen.object3D.addEventListener("interact", this.onPenClick);
    this.cameraBtn.object3D.addEventListener("interact", this.onCameraClick);
    this.inviteBtn.object3D.addEventListener("interact", this.onInviteClick);
    this.participantsBtn.object3D.addEventListener("interact", this.onParticipantsClick);
  },

  pause() {
    this.el.sceneEl.removeEventListener("stateadded", this.onStateChange);
    this.el.sceneEl.removeEventListener("stateremoved", this.onStateChange);
    window.APP.hubChannel.removeEventListener("permissions_updated", this.updateButtonStates);
    this.el.sceneEl.removeEventListener("hub_updated", this.onHubUpdated);

    this.mic.object3D.removeEventListener("interact", this.onMicClick);
    this.spawn.object3D.removeEventListener("interact", this.onSpawnClick);
    this.pen.object3D.removeEventListener("interact", this.onPenClick);
    this.cameraBtn.object3D.removeEventListener("interact", this.onCameraClick);
    this.inviteBtn.object3D.removeEventListener("interact", this.onInviteClick);
    this.participantsBtn.object3D.removeEventListener("interact", this.onParticipantsClick);
  }
});
